import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";

@Component({
    selector: "wbo-order-type-multi-select-column",
    templateUrl: "./order-type-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => OrderTypeMultiSelectColumnComponent), multi: true}
    ]
})
export class OrderTypeMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {
    private _appTypesOnly: boolean = false;

    constructor(injector: Injector) {
        super(injector, "orderType", null, "wbo.order-assignment-rule.edit.option.orderType.");
    }

    @Input()
    get appTypesOnly(): boolean {
        return this._appTypesOnly;
    }

    set appTypesOnly(appTypesOnly: boolean) {
        this._appTypesOnly = appTypesOnly;
        this.i18nLabelPrefix = this._appTypesOnly ? "wbo.order-assignment-rule.edit.option.orderType.app-only." : "wbo.order-assignment-rule.edit.option.orderType.";
    }
}
